import React from "react"
import Page from "@views/Page"
import BecomeDealerPage from "./BecomeDealerPage"
import { allPathsPageQuery, pageQuery } from "@views/Page/graphql"
import requestStaticProps from "@utils/requestStaticProps"
import { GetStaticPaths, GetStaticProps } from "next"

const RoutedPage: React.FC<any> = (props) => {
  const slug = props?.data?.page?.slug
  if (slug === "become-a-dealer") {
    return <BecomeDealerPage data={props.data} />
  }
  return <Page {...props} />
}

export default RoutedPage

export const getStaticPaths: GetStaticPaths = async () => {
  const { data, error } = (await requestStaticProps(allPathsPageQuery)) || {}

  if (error) {
    console.error(error)
  }

  const paths = data.allPages.map(({ slug }) => ({
    params: { slug },
  }))

  return { paths, fallback: false }
}

export const getStaticProps: GetStaticProps = async ({
  params,
  preview = false,
}) => {
  const { data, error } = params?.slug
    ? await requestStaticProps(pageQuery, { slug: params.slug })
    : { data: {}, error: undefined }

  if (error) {
    console.error(error)
  }

  return {
    props: { data },
  }
}
